import { ButtonVariants, IconButton, IconColor } from "@centricsoftware/design-system";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import { IFormField } from "c8-platform";
import { SelectableComponent } from "csi/components/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, MouseEvent } from "react";
import { useFormDefinitionStore } from "./FormDefinitionStore";
import { renderFieldOverlay } from "./SelectableFormFieldOverlay";
import css from "./SelectableFormFields.module.css";

interface SelectableFormFieldProps {
	field: IFormField;
}

export const SelectableFormField: FunctionComponent<SelectableFormFieldProps> = observer(function SelectableFormField({ field }) {
	const {
		activeFieldId,
		canDeleteField,
		deleteField,
		isEditFormDefinitionMode,
		onSelectableComponentClick,
		moveFieldDown,
		moveFieldUp,
		renderKey,
	} = useFormDefinitionStore();
	const onClick = (e: MouseEvent<HTMLElement>): void => onSelectableComponentClick(e, field);
	const moveUp = () => moveFieldUp(field);
	const moveDown = () => moveFieldDown(field);
	const canDelete = () => canDeleteField(field);
	const deleteClick = () => deleteField(field);
	const customMoveUpIcon = () => <MoveUpIcon className={css.iconButtonWhiteBackground} />;
	const customMoveDownIcon = () => <MoveDownIcon className={css.iconButtonWhiteBackground} />;
	const customDeleteIcon = () => <DeleteIcon sx={{ color: "var(--Red300)" }} />;

	const selectedTooltip = (
		<span className={css.selectedTooltip}>
			<IconButton
				color={IconColor.Danger}
				customIcon={customMoveUpIcon}
				onClick={moveUp}
				variant={ButtonVariants.tertiary}
			/>
			<IconButton
				customIcon={customMoveDownIcon}
				onClick={moveDown}
				variant={ButtonVariants.tertiary}
			/>
			{canDelete() && (
				<IconButton
					customIcon={customDeleteIcon}
					onClick={deleteClick}
					variant={ButtonVariants.tertiary}
				/>
			)}
		</span>
	);

	return (
		<SelectableComponent
			className={css.selectableComponent}
			isSelected={activeFieldId === field.id}
			key={renderKey}
			onClick={onClick}
			selectedColor="var(--Blue300)"
			selectedTooltip={!isEditFormDefinitionMode ? null : selectedTooltip}
			tooltipProps={{
				align: "center",
			}}
		>
			{renderFieldOverlay(field)}
		</SelectableComponent>
	);
});